
import {Injectable} from '@angular/core';

//import { APP_SERVE_URL } from '../../../../providers/config/constants';
//import { HttpService } from '../../../providers/service/httpservice';

/**
 * TripService  日历与后台的交互层
 * @description
 */
@Injectable()
export class TripService {

  constructor() {
  }

  static isEmpty(value): boolean {
    return value == null || typeof value === 'string' && value.length === 0;
  }




}



// WEBPACK FOOTER //
// ./src/pages/trip/service/tripservice.ts